/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreateMerchantDefaultRuleFromFlowIdDto,
  GetMerchantDefaultRulesPagedParams,
  InfiniteScrollListMerchantDefaultRuleDtoVoid,
  MerchantDefaultRuleDto,
  UpdateMerchantAutoAccountingRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiMerchantDefaultRulesController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller
   * @name UpdateMerchantDefaultRuleById
   * @request PUT:/api/v1/merchant-default-rules/id/{id}
   */
  updateMerchantDefaultRuleById = (
    id: string,
    data: UpdateMerchantAutoAccountingRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/merchant-default-rules/id/${id}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateMerchantDefaultRuleByIdPath = '/v1/merchant-default-rules/id/${id}'
  static updateMerchantDefaultRuleByIdMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller
   * @name DeleteMerchantDefaultRuleById
   * @request DELETE:/api/v1/merchant-default-rules/id/{id}
   */
  deleteMerchantDefaultRuleById = (id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/merchant-default-rules/id/${id}`,
      method: 'DELETE',
      ...params,
    })

  static deleteMerchantDefaultRuleByIdPath = '/v1/merchant-default-rules/id/${id}'
  static deleteMerchantDefaultRuleByIdMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller
   * @name GetMerchantDefaultRuleByFlowId
   * @request GET:/api/v1/merchant-default-rules/{flowId}
   */
  getMerchantDefaultRuleByFlowId = (flowId: string, params: RequestParams = {}) =>
    this.http.request<MerchantDefaultRuleDto, any>({
      path: `/v1/merchant-default-rules/${flowId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMerchantDefaultRuleByFlowIdPath = '/v1/merchant-default-rules/${flowId}'
  static getMerchantDefaultRuleByFlowIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller
   * @name CreateMerchantDefaultRuleFromFlowId
   * @request POST:/api/v1/merchant-default-rules/{flowId}
   */
  createMerchantDefaultRuleFromFlowId = (
    flowId: string,
    data: CreateMerchantDefaultRuleFromFlowIdDto,
    params: RequestParams = {},
  ) =>
    this.http.request<MerchantDefaultRuleDto, any>({
      path: `/v1/merchant-default-rules/${flowId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createMerchantDefaultRuleFromFlowIdPath = '/v1/merchant-default-rules/${flowId}'
  static createMerchantDefaultRuleFromFlowIdMethod = 'POST'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller
   * @name DeleteMerchantAutoAccountingByFlowId
   * @request DELETE:/api/v1/merchant-default-rules/{flowId}
   * @deprecated
   */
  deleteMerchantAutoAccountingByFlowId = (flowId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/merchant-default-rules/${flowId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteMerchantAutoAccountingByFlowIdPath = '/v1/merchant-default-rules/${flowId}'
  static deleteMerchantAutoAccountingByFlowIdMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller
   * @name GetMerchantDefaultRulesPaged
   * @request GET:/api/v1/merchant-default-rules/paged
   */
  getMerchantDefaultRulesPaged = (
    query: GetMerchantDefaultRulesPagedParams,
    params: RequestParams = {},
  ) =>
    this.http.request<InfiniteScrollListMerchantDefaultRuleDtoVoid, any>({
      path: `/v1/merchant-default-rules/paged`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getMerchantDefaultRulesPagedPath = '/v1/merchant-default-rules/paged'
  static getMerchantDefaultRulesPagedMethod = 'GET'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller
   * @name GetMerchantDefaultRulesByOrgId
   * @request GET:/api/v1/merchant-default-rules/list
   */
  getMerchantDefaultRulesByOrgId = (params: RequestParams = {}) =>
    this.http.request<MerchantDefaultRuleDto[], any>({
      path: `/v1/merchant-default-rules/list`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMerchantDefaultRulesByOrgIdPath = '/v1/merchant-default-rules/list'
  static getMerchantDefaultRulesByOrgIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller
   * @name DeleteDefaultVatByFlowId
   * @request DELETE:/api/v1/merchant-default-rules/{flowId}/vat
   */
  deleteDefaultVatByFlowId = (flowId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/merchant-default-rules/${flowId}/vat`,
      method: 'DELETE',
      ...params,
    })

  static deleteDefaultVatByFlowIdPath = '/v1/merchant-default-rules/${flowId}/vat'
  static deleteDefaultVatByFlowIdMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller
   * @name DeleteDefaultSupplierAccountByFlowId
   * @request DELETE:/api/v1/merchant-default-rules/{flowId}/supplier-account
   */
  deleteDefaultSupplierAccountByFlowId = (flowId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/merchant-default-rules/${flowId}/supplier-account`,
      method: 'DELETE',
      ...params,
    })

  static deleteDefaultSupplierAccountByFlowIdPath =
    '/v1/merchant-default-rules/${flowId}/supplier-account'
  static deleteDefaultSupplierAccountByFlowIdMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller
   * @name DeleteDefaultSubCategoryByFlowId
   * @request DELETE:/api/v1/merchant-default-rules/{flowId}/sub-category
   */
  deleteDefaultSubCategoryByFlowId = (flowId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/merchant-default-rules/${flowId}/sub-category`,
      method: 'DELETE',
      ...params,
    })

  static deleteDefaultSubCategoryByFlowIdPath = '/v1/merchant-default-rules/${flowId}/sub-category'
  static deleteDefaultSubCategoryByFlowIdMethod = 'DELETE'
}
